module.exports = __webpack_public_path__ + "assets/img/13_370_big.4ac87635.jpg";